// noinspection JSUnusedGlobalSymbols
/**
 * Registers a widget with a given name and widget function to be used within the application.
 *
 * @param {string} name - The name of the widget to register. Use the name used in the Widgets XML file.
 * @param {WidgetFunction} widgetFunction - The function that creates the widgets body. This function is called when the widget is created.
 * @return {void} - This method does not return any value.
 */
export function registerWidget(name, widgetFunction) {
    let capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
    let widgetName = `sp${capitalizedName}Widget`;
    // @ts-ignore
    PluginHelper.addWidgetFunction(() => {
        // @ts-ignore
        angular.module('sailpoint.home.desktop.app')
            .directive(widgetName, () => {
            return {
                restrict: 'E',
                scope: {},
                link: widgetFunction
            };
        });
    });
}
